<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>系统菜单</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="insert">新增根菜单</el-button>
        <el-input size="small" placeholder="名称" v-model="condition.menuName"></el-input>
        <el-input size="small" placeholder="地址" v-model="condition.menuUrl"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-table :data="systemMenus" border stripe default-expand-all style="width: 100%" size="mini"
                row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="menuName" label="菜单名称" width="300" sortable>
          <template slot-scope="scope">
            <span v-show="!scope.row.leaf"><i style="font-size:14px" class="el-icon-folder"></i> {{scope.row.menuName}}</span>
            <span v-show="scope.row.leaf"><i style="font-size:14px" class="el-icon-document-copy"></i> {{scope.row.menuName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="menuUrl" label="菜单地址" min-width="400"></el-table-column>
        <el-table-column prop="displayOrder" label="排序" width="80"></el-table-column>
        <el-table-column prop="note" label="备注" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini"  v-show="scope.row.parentId==null" class="global-text-btn-success" type="text"
                       @click="insertSubMenu(scope.row.id, scope.row.menuName)">新增子菜单</el-button>
            <el-button size="mini" type="text" @click="edit(scope.row)" style="margin-left: 10px;">编辑</el-button>
            <el-button size="mini" class="global-text-btn-danger" type="text" style="margin-left: 10px;"
                       @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemMenu" :rules="rules" label-width="80px" size="small">
        <el-form-item label="父菜单" prop="type">
          <el-input v-model="systemMenu.parentName" readonly></el-input>
        </el-form-item>
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="systemMenu.menuName"></el-input>
        </el-form-item>
        <el-form-item label="菜单地址" prop="menuUrl">
          <el-input v-model="systemMenu.menuUrl"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input v-model="systemMenu.displayOrder"></el-input>
        </el-form-item>
        <el-form-item label="完整编号" prop="menuRoot">
          <el-input v-model="systemMenu.menuRoot" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="systemMenu.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemMenuIndex',
  data () {
    return {
      // 系统菜单列表
      systemMenus: [],
      // 遮罩
      loading: {main: false, editDialog: false},
      // 可见
      visible: {editDialog: false},
      // 条件
      condition:{},
      // 系统参数
      systemMenu: {},
      // 校验规则
      rules: {
        menuName: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        menuUrl: [
          { max: 100, message: '长度最多50个字符', trigger: 'change' }
        ],
        displayOrder: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      }
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.findByCondition();
  },
  
  methods: {
    /*
     * 查询所有
     */
    findByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      // 请求后台
      vm.$http.get('rest/sys/systemMenu/findByCondition', {params: params}).then(response => {
        vm.systemMenus = response.body.systemMenus;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.systemMenu = {displayOrder:0}
    },
    /*
     * 新增子菜单
     */
    insertSubMenu: function (parentId, parentName) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemMenu = {parentId:parentId, parentName:parentName, displayOrder:0}
    },
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemMenu = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + (record.parentName==null?"":record.parentName+'_')+record.menuName + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemMenu/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition()
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemMenu/saveData', vm.systemMenu).then(function (response) {
          vm.systemMenu = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false
          vm.findByCondition()
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemmenu/SystemMenuIndex.vue